import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

class LanguageSelect extends React.Component {
  constructor(props) {
    super();

    //console.log('LanguageSelect',props);

    const languages = [
      { iso: "en", label: "English" },
      { iso: "de", label: "Deutsch" },
      //{iso:'it',label:'Italiano'},
      //{iso:'es',label:'Español'},
      // {iso:'hu',label:'Magyar'}
    ];

    let currentLanguage = props.currentLanguage.data || "en";

    //console.log('LanguageSelect',currentLanguage);

    this.state = {
      currentLanguage,
      languages,
      open: false,
    };

    this.toggleList = this.toggleList.bind(this);

    this.selectLanguage = this.selectLanguage.bind(this);
    //setTimeout(this.checkForUserLanguage , 500);
  }

  selectLanguage(currentLanguage) {
    if (currentLanguage) {
      let exdays = 30;

      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();

      document.cookie =
        "language=" + currentLanguage + ";" + expires + ";path=/";

      this.props.setLanguage(currentLanguage);
      this.setState({ currentLanguage, open: false });

      document.querySelector("html").setAttribute("lang", currentLanguage);
    } else {
      console.warn("Language not found", currentLanguage);
    }
  }

  toggleList() {
    let open = !this.state.open;
    this.setState({ open });
  }

  render() {
    return (
      <div className={"language-selector"}>
        <div className="list-toggle"></div>
        <div className="list">
          {this.state.languages.map((item, i) => {
            return (
              <div
                key={"l" + i}
                className={
                  "label " +
                  (this.state.currentLanguage === item.iso ? "current" : "")
                }
                onClick={() => {
                  this.selectLanguage(item.iso);
                }}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStatesToProps = (state) => {
  const currentLanguage = state.KastnerStore.currentLanguage;
  return {
    currentLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLanguage: (data) => {
      //console.log('ScrollIndex',index,max,dir)
      dispatch({ type: "SELECT_LANGUAGE", payload: data });
    },
  };
};

export default connect(mapStatesToProps, mapDispatchToProps)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/modules/menu/LanguageSelect.js